import { useEffect } from "react";
import { ButtonTypes } from "../../../../../Definitions";
import { colors, fonts, frames, glyphs } from "../../../../../Styles";
import { useLazyQuery, useMutation } from "@apollo/client";
import { LoadingSpinner } from "../../../../../Services/wrapper";
import { LAN_CONTROLLER_MQTT_CONFIG, LANControllerMQTTConfigArgs, LANControllerMQTTConfigResponse } from "../../../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/lanControllerMQTTConfig";
import { LAN_CONTROLLER_CONFIG, LANControllerConfigArgs, LANControllerConfigResponse } from "../../../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/lanControllerConfig";
import NewButton from "../../../../../Components/BaseComponents/newButton";
import { AicoConnection, PageHeader, useAicoConnection } from "../../../../../Components";
import { LC_REBOOT, LCRebootArgs, LCRebootResponse } from "../../../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/lcReboot";

export default function LANControllerConfig() {
	const { state: connectionState } = useAicoConnection();

	const [configFetch, { data: configData, loading: configLoading, error: configError }] = useLazyQuery<LANControllerConfigResponse, LANControllerConfigArgs>(LAN_CONTROLLER_CONFIG, {
		fetchPolicy: "network-only"
	});

	const [mqttFetch, { data: mqttData, loading: mqttLoading, error: mqttError }] = useLazyQuery<LANControllerMQTTConfigResponse, LANControllerMQTTConfigArgs>(LAN_CONTROLLER_MQTT_CONFIG, {
		fetchPolicy: "network-only"
	});

	const [rebootFetch, { data: rebootData, loading: rebootLoading, error: rebootError }] = useMutation<LCRebootResponse, LCRebootArgs>(LC_REBOOT, {
		fetchPolicy: "network-only"
	});

	useEffect(() => {
		if (connectionState.deviceConnection) {
			configFetch({ variables: connectionState.deviceConnection });
			mqttFetch({ variables: connectionState.deviceConnection });
		}
	}, [connectionState.deviceConnection]);

	const loading = configLoading || mqttLoading;

	const error = configError || mqttError;

	return (
		<frames.Page_inner>
				<PageHeader topHeader='Aico Tables' subHeader='Config' />
			<frames._page_inner_content>
				<frames._grid_topBtns_outer>
					<frames._grid_topBtns_inner style={{ position: "relative", justifyContent: "end" }}>
						<div style={{ position: "absolute", top: "50%", transform: "translateY(-50%)", left: "20px" }}><AicoConnection/></div>
						<NewButton
							content={"fetch"}
							buttonType={ButtonTypes.tableButton}
							startEnhancer={glyphs.Fetch({})}
							onClick={() => {
								if (connectionState.deviceConnection) {
									configFetch({ variables: connectionState.deviceConnection });
									mqttFetch({ variables: connectionState.deviceConnection });
								}
							}}
							disabled={loading}
						/>
					</frames._grid_topBtns_inner>
					<div style={{ gridArea: "2/1/3/2", border: "5px solid " + colors.greyPrimary, overflow: "hidden", borderRadius: "10px", backgroundColor: colors.greyLightTertiary }}>
						{loading ?
							<LoadingSpinner />
							: error ?
								<div style={{ color: "#aa0000" }}>Error</div>
								:
								<>
									<div style={{ textAlign: "left", ...fonts.fontSize1, ...fonts.header, color: colors.greyDarkPrimary }}>config </div>
									<div style={{ textAlign: "left", ...fonts.paragraph, color: colors.greyDarkPrimary }}>
										{configData?.controller.config ? (
											<>
												<div>CPU ID: {configData.controller.config.cpuId} </div>
												<div>MAC Address: {configData.controller.config.macAddress} </div>
												<div>IP Address: {configData.controller.config.ipAddress} </div>
												<div>Firmware Version: {configData.controller.config.firmwareVersion} </div>
												<div>Server Protocol Version: {configData.controller.config.serverProtocolVersion} </div>
												<div>Table Definition Version: {configData.controller.config.tableDefinitionVersion} </div>
												<div>Product Name: {configData.controller.config.productName} </div>
												<div>Hardware Version: {configData.controller.config.hardwareVersion} </div>
												<div>Production Date: {configData.controller.config.productionDate} </div>
											</>
										) : (<div>No Data</div>)
										}
									</div>

									<div style={{ textAlign: "left", ...fonts.fontSize1, ...fonts.header, color: colors.greyDarkPrimary }}>mqtt config </div>
									<div style={{ textAlign: "left", ...fonts.paragraph, color: colors.greyDarkPrimary }}>
										{mqttData?.controller.mqttConfig ? (
											<>
												<div>Domain: {mqttData.controller.mqttConfig.domain} </div>
												<div>Password: {mqttData.controller.mqttConfig.password} </div>
												<div>IP Address: {mqttData.controller.mqttConfig.ipAddress} </div>
											</>
										) : (<div>no data</div>)
										}
									</div>
								</>
						}

						<NewButton
							content={"Reboot"}
							disabled={rebootLoading}
							onClick={() => {
								if (connectionState.deviceConnection) {
									rebootFetch({ variables: connectionState.deviceConnection });
								}
							}}
						/>
						{rebootLoading && <LoadingSpinner />}
						{(rebootError
							|| (rebootData?.controller && !rebootData.controller.reboot?.success)
						)
							&& <p style={{ ...fonts.fontSize4, ...fonts.paragraph, color: colors.systemRed, maxWidth: "500px" }}>Error: failed to reboot device</p>
						}
						{!rebootLoading
							&& !rebootError
							&& rebootData?.controller.reboot?.success
							&& <p style={{ ...fonts.fontSize4, ...fonts.paragraph, color: colors.systemGreen, maxWidth: "500px" }}>Succesfully rebooted LC</p>
						}
					</div>
				</frames._grid_topBtns_outer>
			</frames._page_inner_content>
		</frames.Page_inner>
	)
}